import React, { useState, useRef, useEffect } from "react";
import DynamicDropdown from "./Dropdown";
import { favoriteDropdownData, helpdropdownData } from "../utils/headerDropdownData";
import { useDispatch, useSelector } from "react-redux";
import { addTab, closeAllTabs, setActiveTab } from "../redux/action/tab.action";
import { fetchFacilities, setSelectedFacility } from "../redux/action/facility.action";
import { downloadSample } from "../services/GlobalService/global.service";
import { toast } from "./AppToast";
import Loader from '../components/Loader';
import { getMenuBasedOnFacility } from "../services/global/global";
import { setPermissions } from "../redux/action/permissions.action";
import { sortMenusWithDataSetupLast } from "../utils/sidebarUtils";
import { AiAssistantDrawer } from "./AiAssistant/AiAssistant";
const HEADER_NOTIFICATIONS = [
  {
    id: "po-10482",
    title: "Purchase order created",
    text: "PO-10482 was created for Northwind Retail.",
    time: "2 min ago",
    icon: "bi-file-earmark-text",
    tone: "po",
    unread: true,
  },
  {
    id: "asn-2291",
    title: "ASN created",
    text: "ASN-2291 was created against PO-10482.",
    time: "18 min ago",
    icon: "bi-truck",
    tone: "asn",
    unread: true,
  },
  {
    id: "so-8831",
    title: "Sales order created",
    text: "SO-8831 was created for Harbor Home Stores.",
    time: "1 hr ago",
    icon: "bi-cart-check",
    tone: "sales",
    unread: true,
  },
  {
    id: "shp-4410",
    title: "Shipment created",
    text: "Shipment SHP-4410 was created for SO-8831.",
    time: "3 hr ago",
    icon: "bi-box-seam",
    tone: "shipment",
    unread: false,
  },
  {
    id: "po-10471",
    title: "Purchase order created",
    text: "PO-10471 was created for Lumen Electronics.",
    time: "Yesterday",
    icon: "bi-file-earmark-text",
    tone: "po",
    unread: false,
  },
];

const Header = ({ toggleSidebar, onLogout }) => {
  const dispatch = useDispatch();
  const { tabs, activeTab } = useSelector((state) => state.tab);
  const { userDetail } = useSelector((state) => state.login);
  const { facilities, loading, error, selectedFacility } = useSelector((state) => state.facility);

  const filteredHelpDropdownData = helpdropdownData.filter((item) => {
  if (item.value === "AdminSettings") {
    return userDetail?.userType === "TENANT_ADMIN";
  }

  return true;
});

  // console.log("Header selectedFacility:", selectedFacility);

  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showFacilityDropdown, setShowFacilityDropdown] = useState(false);
  const [showToolsDropdown, setShowToolsDropdown] = useState(false); // NEW
  const [showAiAssistant, setShowAiAssistant] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState(HEADER_NOTIFICATIONS);
  // const [showFavoriteDropdown, setShowFavoriteDropdown] = useState(false);
  // const [selectedFacility, setSelectedFacility] = useState(
  //   facilityDropdownData[0] || { label: "WHD-1", value: "whd_1" }
  // );
  const [showFavoriteDropdown, setShowFavoriteDropdown] = useState(false);
  const [selectedFavorite, setSelectedFavorite] = useState(
    favoriteDropdownData[0] || { label: "Dashboard", value: "dashboard" }
  );
  
  const toolsDropdownRef = useRef(null); // NEW
  const notificationRef = useRef(null);
  const dropdownRef = useRef(null);
  const facilityDropdownRef = useRef(null);
  const favoriteDropdownRef = useRef(null);
  const fileInputRef = useRef(null); // NEW

  const TOOLS_ITEMS = [
    { label: "Excel Imports/Exports", value: "download_excel" },
    // { label: "Upload Excel", value: "upload_excel" },
  ];

  // Header.jsx (event handler)
  const handleClick = async (item) => {
    const path = item?.path || "";      // item se path lo
    const label = item?.label || "";    // tab title ke liye

    try {
      // If item.path is an external URL, just open in new tab
      if (/^https?:\/\//i.test(path)) {
        window.open(path, "_blank", "noopener,noreferrer");
        setShowUserDropdown(false);
        return;
      }

      // If path is a special value indicating user guide / sample download
      // (configure this in your helpdropdownData, e.g. path: 'user_guide' and optionally type)
      if (path === "user_guide" || /user\s*guide/i.test(label) || item?.value === "help1") {
        // item.type could carry requested sample type; fallback to 'trainingsmall'
        const type = item?.type || "trainingsmall";
        // Optionally pass token: if your axios instance does NOT add Authorization automatically and
        // userDetail has token, you can pass it. Example: downloadSample(type, userDetail?.token)
        await downloadSample(type);
        setShowUserDropdown(false);
        return;
      }

      // Default: internal route → tabs state me open/activate
      const idx = tabs.findIndex((t) => t.path === path);
      if (idx !== -1) {
        dispatch(setActiveTab(idx));
      } else {
        // determine content key so TabWrapper can resolve the correct component
        let contentKey = label || path;

        // map known internal routes to componentMap keys
        if (path === "/AdminSettings" || item?.value === "AdminSettings") {
          contentKey = "AdminSettings";
        } else if (path === "/settings" || item?.value === "settings") {
          contentKey = "Settings";
        }

        dispatch(addTab({ title: label || "Settings", path, content: contentKey }));
      }
      setShowUserDropdown(false);
    } catch (err) {
      console.error("Failed to open help item:", err);
      // optionally show an alert / toast
      alert(err.message || "Failed to open user guide");
      setShowUserDropdown(false);
    }
  };



  // useEffect(() => {
  //   if (facilities?.length > 0 && !selectedFacility) {
  //     // ONLY auto-select if nothing saved
  //     const defaultFacility = {
  //       label: facilities[0].Facility_Name,
  //       value: facilities[0].Facility_ID,
  //       id: facilities[0]._id
  //     };

  //     dispatch(setSelectedFacility(defaultFacility));
  //   }
  // }, [facilities, selectedFacility]);

 



  const handleFacilitySelect = (facility) => {
    // Show loader ON
    dispatch({ type: "FACILITY_SWITCH_LOADING", payload: true });

    setShowFacilityDropdown(false);

    setTimeout(() => {
      // Set selected facility
      dispatch(setSelectedFacility(facility));

      // Close all tabs
      dispatch(closeAllTabs());

      // Turn OFF loader
      dispatch({ type: "FACILITY_SWITCH_LOADING", payload: false });

      toast.success(`Facility switched to: ${facility.label}`);
    }, 800); // small wait to feel the transition

    if(userDetail.userType=="TENANT_USER"){
     fetchMenus(facility);
    }
    

  };

  const fetchMenus = async (facility) => {
    try {
    const roleId = userDetail.roleFacilityAccess.find(f=>f.facilityName==facility.value)
    
     const payload = {
      userId:userDetail._id,
      tenantId:userDetail.tenantId,
      iat:userDetail.iat,
      exp:userDetail.exp,
      role:userDetail.userType,
      roleIdd:roleId.roleId._id
    };

      const data = await getMenuBasedOnFacility(payload);
  
      const updatedMenu = sortMenusWithDataSetupLast(
        data.map((el) => ({
          ...el,
          collapsed: false,
        }))
      );
  
      // 🔥 Store menus in Redux
      dispatch(setPermissions(updatedMenu));
  
    } catch (err) {
      toast.error(`Failed to fetch menus: ${err}`);
    }
  };

  // const handleFavoriteSelect = (favorite) => {
  //   setSelectedFavorite(favorite);
  //   setShowFavoriteDropdown(false);
  //   console.log("Selected Favorite:", favorite);
  // };

  const handleToolsSelect = (item) => {
    if (!item) return;
    // Open Tools page as a new tab (TabWrapper maps 'Tools')
    const path = `/tools/${item.value}`; // unique-ish path per action
    const title = " Imports/Exports";
    // add tab and activate it
    dispatch(addTab({ title, path, content: "Tools" }));
    // activate the new tab (it will be appended to tabs in parent)
    // parent Tab state reducer typically sets active to last; if not, we set active by index after adding.
    setShowToolsDropdown(false);
  };

  const handleFileInputChange = async (e) => {
    const f = e.target.files && e.target.files[0];
    if (!f) return;
    // Placeholder: replace with real upload logic
    console.log("Selected file for upload:", f);
    toast.success(`Selected file: ${f.name}`);
    // reset input so user can pick same file again later
    e.target.value = "";
  };

  // Fetch facilities on component mount using Redux
  useEffect(() => {
    dispatch(fetchFacilities());
  }, [dispatch]);

  // useEffect(() => {
  //   console.log(selectedFacility,facilities,"selectedFacility");
    
  //   if (facilities && facilities.length > 0 && !selectedFacility) {
  //      const defaultFacility = facilities.find(f => f.defaultWh === true);

  //   if (defaultFacility) {
  //     handleFacilitySelect({
  //       label: defaultFacility.Facility_Name,
  //       value: defaultFacility.Facility_ID,
  //       id: defaultFacility._id
  //     });
  //     dispatch(setSelectedFacility(defaultFacility));

  //   }
  //   else
  //   {
  //       const defaultFacility = {
  //       label: facilities[0].Facility_Name,
  //       value: facilities[0].Facility_ID,
  //       id: facilities[0]._id
  //     };
  //     dispatch(setSelectedFacility(defaultFacility));

  //   }
    
  //   }
  // }, [facilities, selectedFacility, dispatch]);


  useEffect(() => {
  if (!facilities?.length) return;

 
  const defaultFacility =
    facilities.find(f => f.defaultWh === true) || facilities[0];

  const selected = {
    label: defaultFacility.Facility_Name,
    value: defaultFacility.Facility_ID,
    id: defaultFacility._id
  };

  dispatch(setSelectedFacility(selected));
}, [facilities, dispatch]);


  // Close dropdowns when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowUserDropdown(false);
      }
      if (facilityDropdownRef.current && !facilityDropdownRef.current.contains(event.target)) {
        setShowFacilityDropdown(false);
      }
      if (toolsDropdownRef.current && !toolsDropdownRef.current.contains(event.target)) {
        setShowToolsDropdown(false);
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      // if (favoriteDropdownRef.current && !favoriteDropdownRef.current.contains(event.target)) {
      //   setShowFavoriteDropdown(false);
      // }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="header_container d-flex justify-content-between align-items-center">
      {/* Left side - compact layout */}
      {loading && <Loader />}

      <div className="d-flex align-items-center gap-3">
        {/* AI Assistant — left of Facility */}
        <div
          className={`ai-assistant-trigger ${showAiAssistant ? "ai-assistant-trigger--active" : ""}`}
          onClick={() => setShowAiAssistant((prev) => !prev)}
          title="AI Assistant"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setShowAiAssistant((prev) => !prev);
            }
          }}
        >
          <i className="bi bi-stars me-1 ai-assistant-trigger__icon" aria-hidden="true" />
          <span className="ai-assistant-trigger__label">AI Assistant</span>
        </div>

        {/* Facility Dropdown - Compact */}
        <div className="dropdown simple-dropdown" ref={facilityDropdownRef}>
          <div
            className="location-dropdown-trigger d-flex align-items-center cursor-pointer px-2 py-1"
            onClick={() => setShowFacilityDropdown(!showFacilityDropdown)}
          >
            <i className="bi bi-geo-alt-fill me-1" style={{ color: '#6c757d', fontSize: '0.9rem' }}></i>
            <span style={{ 
              fontSize: '0.8rem', 
              color: '#495057', 
              fontWeight: '500'
            }}>
              {selectedFacility?.label || "Select Location"}
            </span>
            <i 
              className={`bi bi-chevron-${showFacilityDropdown ? 'up' : 'down'} ms-1`} 
              style={{ fontSize: '0.6rem', color: '#6c757d' }}
            ></i>
          </div>
          
          {showFacilityDropdown && (
            <div className="facility-dropdown-menu">
              {facilities.length > 0 ? (
                facilities.map((facility, index) => (
                  // console.log("facility", facility),
                  <div
                    key={facility._id || index}
                    className={`facility-dropdown-item ${selectedFacility?.Facility_ID === facility.Facility_ID ? 'active' : ''}`}
                    onClick={() => handleFacilitySelect({
                      label: facility.Facility_Name,
                      value: facility.Facility_ID,
                      id: facility._id
                    })}
                  >
                    <div className="facility-icon">
                      <i className="bi bi-geo-alt-fill"></i>
                    </div>
                    <div className="facility-content">
                      <div className="facility-name">{facility.Facility_Name}</div>
                      <div className="facility-type">{facility.Facility_ID}</div>
                    </div>
                    {selectedFacility?.Facility_ID === facility.Facility_ID && (
                      <i className="bi bi-check text-primary ms-auto"></i>
                    )}
                  </div>
                ))
              ) : (
                <div className="facility-dropdown-item">
                  <div className="facility-content">
                    <div className="facility-name">No facilities found</div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Tools Dropdown - Compact */}
        <div className="dropdown simple-dropdown" ref={toolsDropdownRef}>
          <div
            className="simple-dropdown-trigger d-flex align-items-center cursor-pointer px-2 py-1"
            onClick={() => setShowToolsDropdown(!showToolsDropdown)}
            title="Tools"
          >
            <i className="bi bi-tools me-1" style={{ color: '#6c757d', fontSize: '0.9rem' }}></i>
            <span style={{ fontSize: '0.8rem', color: '#495057', fontWeight: '500' }}>Tools</span>
            <i className={`bi bi-chevron-${showToolsDropdown ? 'up' : 'down'} ms-1`} style={{ fontSize: '0.6rem', color: '#6c757d' }}></i>
          </div>
          {showToolsDropdown && (
            <div className="position-absolute bg-white shadow rounded py-1 mt-1" style={{ minWidth: 170, zIndex: 1050 }}>
              {TOOLS_ITEMS.map((it, idx) => (
                <button key={idx} className="dropdown-item py-2" onClick={() => handleToolsSelect(it)}>
                  <i className={it.value === "download_excel" ? "bi bi-download me-2" : "bi bi-upload me-2"}></i>
                  {it.label}
                </button>
              ))}
            </div>
          )}
        </div>
        {/* hidden file input used by Tools -> Upload Excel */}
        <input ref={fileInputRef} type="file" accept=".xlsx,.xls,.csv" style={{ display: "none" }} onChange={handleFileInputChange} />

        {/* Favorites Dropdown - Compact */}
         {/* <div className="dropdown simple-dropdown" ref={favoriteDropdownRef}>
          <div
            className="simple-dropdown-trigger d-flex align-items-center cursor-pointer px-2 py-1"
            onClick={() => setShowFavoriteDropdown(!showFavoriteDropdown)}
          >
            <i className="bi bi-star-fill me-1" style={{ color: '#ffc107', fontSize: '0.9rem' }}></i>
            <span style={{ 
              fontSize: '0.8rem', 
              color: '#495057', 
              fontWeight: '500'
            }}>
              {selectedFavorite?.label || "Favorites"}
            </span>
            <i 
              className={`bi bi-chevron-${showFavoriteDropdown ? 'up' : 'down'} ms-1`} 
              style={{ fontSize: '0.6rem', color: '#6c757d' }}
            ></i>
          </div>
          
          {showFavoriteDropdown && (
            <ul className="dropdown-menu show">
              {favoriteDropdownData.map((favorite, index) => (
                <li key={index}>
                  <button
                    className={`dropdown-item ${selectedFavorite?.value === favorite.value ? 'active' : ''}`}
                    onClick={() => handleFavoriteSelect(favorite)}
                  >
                    <i className="bi bi-star me-2"></i>
                    {favorite.label}
                    {selectedFavorite?.value === favorite.value && (
                      <i className="bi bi-check ms-auto text-primary"></i>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>  */}
      </div>

      {/* Right side - notifications, then user profile */}
      <div className="d-flex align-items-center gap-1">
        <div className="header-notifications" ref={notificationRef}>
          <button
            type="button"
            className={`header-notifications__btn${showNotifications ? " is-open" : ""}`}
            aria-label="Notifications"
            aria-expanded={showNotifications}
            onClick={() => setShowNotifications((open) => !open)}
          >
            <i className="bi bi-bell" aria-hidden />
            {notifications.some((item) => item.unread) && (
              <span className="header-notifications__badge">
                {notifications.filter((item) => item.unread).length}
              </span>
            )}
          </button>

          {showNotifications && (
            <div className="header-notifications__panel" role="dialog" aria-label="Notification list">
              <div className="header-notifications__head">
                <span>Notifications</span>
                <button
                  type="button"
                  className="header-notifications__mark"
                  onClick={() => setNotifications((list) => list.map((item) => ({ ...item, unread: false })))}
                >
                  Mark all read
                </button>
              </div>
              <ul className="header-notifications__list">
                {notifications.map((item) => (
                  <li key={item.id}>
                    <button
                      type="button"
                      className={`header-notifications__item${item.unread ? " is-unread" : ""}`}
                      onClick={() =>
                        setNotifications((list) =>
                          list.map((row) => (row.id === item.id ? { ...row, unread: false } : row))
                        )
                      }
                    >
                      <span className={`header-notifications__icon header-notifications__icon--${item.tone}`}>
                        <i className={`bi ${item.icon}`} aria-hidden />
                      </span>
                      <span className="header-notifications__copy">
                        <span className="header-notifications__title">{item.title}</span>
                        <span className="header-notifications__text">{item.text}</span>
                        <span className="header-notifications__time">{item.time}</span>
                      </span>
                      {item.unread && <span className="header-notifications__dot" aria-hidden />}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="dropdown simple-dropdown" ref={dropdownRef}>
          <div
            className="user-profile-trigger d-flex align-items-center cursor-pointer px-2 py-1"
            onClick={() => setShowUserDropdown(!showUserDropdown)}
          >
            {/* <div className="user-avatar me-2">
              <i className="bi bi-person-circle" style={{ fontSize: '2.8rem', color: '#6c757d' }}></i>
            </div> */}
            <div className="user-details me-2">
              <div className="user-name" style={{ 
                fontSize: '0.75rem', 
                fontWeight: '600', 
                color: '#212529',
                marginBottom: '1px',
                lineHeight: '1.1'
              }}>
                User Name: {userDetail?.firstName} {userDetail?.lastName}
              </div>
              <div className="user-role" style={{ 
                fontSize: '0.7rem', 
                color: '#6c757d',
                lineHeight: '1.1'
              }}>
                User Role: {userDetail?.userType || 'ADMIN'}
              </div>
            </div>
            <i 
              className={`bi bi-chevron-${showUserDropdown ? 'up' : 'down'}`} 
              style={{ fontSize: '0.6rem', color: '#6c757d' }}
            ></i>
          </div>

          {showUserDropdown && (
            <div
              className="position-absolute bg-white shadow rounded py-2 dropdown-menu show mt-1"
              style={{ minWidth: '200px', right: 0, zIndex: 1050 }}
            >
              <h6 className="dropdown-header">Help & Settings</h6>
              {filteredHelpDropdownData.map((item, index) => (
                <button
                  key={index}
                  className="dropdown-item py-2"
                  onClick={() => handleClick(item)}
                >
                  <i
                    className={`${
                      // User Guide? show a book/journal icon
                      (item.value === "help1" || /user guide/i.test(item.label))
                        ? "bi-journal-text"
                        : "bi-gear-fill"
                      } me-2 ${/^https?:\/\//i.test(item.path) ? "text-muted" : "text-muted"}`}
                  ></i>
                  {item.label}
                </button>
              ))}


              <hr className="dropdown-divider m-0" />
              <button
                className="dropdown-item py-2 text-danger"
                onClick={onLogout}
              >
                <i className="bi bi-box-arrow-right me-2"></i>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>

      <AiAssistantDrawer open={showAiAssistant} onClose={() => setShowAiAssistant(false)} />
    </div>
  );
};

export default Header;